"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CssScrollerDiv2 = exports.CssScrollerDiv = exports.CssScroller = void 0;
var styled_components_1 = __importStar(require("styled-components"));
exports.CssScroller = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  ", "\n"], ["\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var _b = _a.bgThumb, bgThumb = _b === void 0 ? "#c2bdbd" : _b, _c = _a.bgTrack, bgTrack = _c === void 0 ? "#f5f5f5" : _c, _d = _a.width, width = _d === void 0 ? "5px" : _d, _e = _a.offset, offset = _e === void 0 ? 0 : _e;
    return "\n    /* width */\n  ::-webkit-scrollbar {\n    width: " + width + ";\n    height: " + width + ";\n  }\n  /* Track */\n  ::-webkit-scrollbar-track {\n    background: " + bgTrack + ";\n    border-radius: 15px;\n  }\n  /* Handle */\n\n  ::-webkit-scrollbar-thumb {\n    background: " + bgThumb + ";\n    border-radius: 15px;\n  }\n\n  /* scrollbar offset */\n  margin-right: -" + offset + "px;\n  padding-right: " + offset + "px;\n  ";
}, function (_a) {
    var defaultYScroller = _a.defaultYScroller;
    return defaultYScroller
        ? "\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n  "
        : "";
});
exports.CssScrollerDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), exports.CssScroller);
exports.CssScrollerDiv2 = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ",
    "\n"])), exports.CssScroller, function (_a) {
    var overflowXAuto = _a.overflowXAuto, overflowYAuto = _a.overflowYAuto;
    return "\n    " + (overflowXAuto ? "overflow-x: auto; width: 100%;" : "") + "\n    " + (overflowYAuto ? "overflow-y: auto; height: 100%;" : "") + "\n  ";
});
var templateObject_1, templateObject_2, templateObject_3;
